import React from 'react'
import styled from '@emotion/styled'

import { Text, FadedText } from 'Components/shared/Typography'
import { Grid } from 'lese'

import { convertToReadableDate, statusToStatus, toTitleCase } from 'Helpers'

import ListItem from 'Components/shared/ListItem'
import AlertIcon from 'Components/shared/AlertIcon'

const EncounterItemGrid = styled(ListItem)`
  box-sizing: border-box;
  border-top: 0.5px solid #c4c4c4;
  background: ${({ isNew }) => (isNew ? '#DFF0FA' : 'transparent')};
  border: ${({ isSelected }) => (isSelected ? '#000 1.32px solid' : '')};
  padding: 8px;
`.withComponent(Grid)

const RefText = styled(Text)`
  font-size: 1.1rem;
`
const Small = styled(Text)`
  font-size: 0.8rem;
`

export default React.memo(
  ({
    alertLevel,
    isNew,
    medicalRef,
    tCode,
    date,
    journey,
    setSelection,
    hl7Id,
    isSelected,
    reviewer,
    status,
    appCode,
    bio,
    inactiveType,
    inactiveDays,
    isClusterUser,
    ...props
  }) => {
    return (
      <EncounterItemGrid
        columns="24px 200px auto auto"
        row="1fr 1fr 1fr"
        gap="4px 9px"
        yAlign="center"
        isSelected={isSelected}
        onClick={() => setSelection(hl7Id)}
        isNew={isNew}
        alt={`Encounter ${hl7Id}`}
        {...props}
      >
        {alertLevel !== 'NONE' && (
          <AlertIcon
            alertEnum={alertLevel}
            inactiveType={inactiveType}
            inactiveDays={inactiveDays}
          />
        )}
        <RefText columnSelf="2">Pt#: {medicalRef}</RefText>
        <Small>Sts: {toTitleCase(statusToStatus(status))} </Small>
        <Small align="right">Revr: {reviewer}</Small>
        <FadedText columnSelf="2 / span 4">{journey}</FadedText>
        <Small columnSelf="2">
          {tCode} | {convertToReadableDate(date)}
        </Small>
        <Small>{bio}</Small>
        {isClusterUser && <Small align="right">{appCode}</Small>}
      </EncounterItemGrid>
    )
  }
)
